import loadable from '@loadable/component'
import React from 'react'
import { FeatureToggle } from '../../../feature-toggling/Toggle/Toggle'
import { TokyoPodcastPageProps } from './TokyoPodcastPage'

const LazyTokyoPodcastPlayerComponent = loadable(
    () => import('./TokyoPodcastPage'),
)

// Standalone lazy load component
export const LazyTokyoPodcastPage = (props: TokyoPodcastPageProps) => {
    return (
        <FeatureToggle
            feature="the-west-tokyo-podcast"
            on={() => <LazyTokyoPodcastPlayerComponent {...props} />}
        />
    )
}
